import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import actions from './actions';
import ListaAcoes from '../../components/ListaAcoes';

import constants from './constants';

class ListaRolesContratrantes extends Component {
  render() {
    let { value, actions } = this.props;

    return (
      <ListaAcoes
        title="Roles Contratantes"
        value={value}
        actions={{
          onLoad: actions.onLoadListRolesContratantes,
          onCancel: actions.onChangeListRolesContratantes(
            constants.Status.CANCELADA
          ),
          onApprove: actions.onChangeListRolesContratantes(
            constants.Status.CONFIRMADA
          ),
          onCreate: actions.onChangeListRolesContratantes(
            constants.Status.CONFIRMADA
          )
        }}
        labelFn={item => (
          <div>
            {item.apartamento} {item.nome_role} : {item.nome_usuario}
            <br />
            {item.nome_contratante}
          </div>
        )}
      />
    );
  }
}

let mapStateToProps = ({ admin: { rolesContratantes } }) => ({
  value: rolesContratantes
});

let mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(actions, dispatch)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ListaRolesContratrantes);



// WEBPACK FOOTER //
// ./src/modules/admin/ListaRolesContratantes.js